import { type AnyAction } from 'redux';
import {
    BLOCK_NAVIGATION,
    UNBLOCK_NAVIGATION
} from '../actions/actionTypes/blockNavigation';

const initialState = false;

export const blockNavigation = (state = initialState, action: AnyAction): boolean => {
    switch (action.type) {
        case BLOCK_NAVIGATION:
            return true;
        case UNBLOCK_NAVIGATION:
            return false;
        default:
            return state;
    }
};
